<form [formGroup]="editorFormGroup"
      *ngrxLet="params$; let params;"
      [style.width.px]="params?.eGridCell?.clientWidth"
      [ngClass]="{ 'border-[#D62D1A]': editorFormGroup.invalid && editorFormGroup.touched }"
      cdkTrapFocus>
  <div class="flex flex-col">
    <mat-form-field
        appearance="fill"
        class="textFormField">
      <mat-label>latitude</mat-label>

      <input
          #latitudeInput
          type="text"
          matInput
          appGxInput
          formControlName="latitude">

      @if (latitudeInput?.value?.length) {
        <div class="copyIcon"
             (click)="copyTextInput(latitudeInput)">
          <mat-icon svgIcon="content_copy"></mat-icon>
        </div>
      }

      @if (editorFormGroup.invalid) {
        <mat-error
            class="flex items-center"
            [matTooltip]="getErrorMessage(editorFormGroup.get('latitude'))">
          <mat-icon svgIcon="error" class="errorIcon"></mat-icon>
          <span class="truncate">{{getErrorMessage(editorFormGroup.get('latitude'))}}</span>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field
        appearance="fill"
        class="textFormField">
      <mat-label>longitude</mat-label>

      <input
          #longitudeInput
          type="text"
          matInput
          appGxInput
          formControlName="longitude">

      @if (longitudeInput?.value?.length) {
        <div class="copyIcon"
             (click)="copyTextInput(longitudeInput)">
          <mat-icon svgIcon="content_copy"></mat-icon>
        </div>
      }

      @if (editorFormGroup.invalid) {
        <mat-error
            class="flex items-center"
            [matTooltip]="getErrorMessage(editorFormGroup.get('longitude'))">
          <mat-icon svgIcon="error" class="errorIcon"></mat-icon>
          <span class="truncate">{{getErrorMessage(editorFormGroup.get('longitude'))}}</span>
        </mat-error>
      }
    </mat-form-field>
  </div>
</form>
